import { useState, useEffect } from "react";
const keyDefault = "column_control";
type ColunmName =
  | "remnants"
  | "reserved"
  | "combo_distribution"
  | "distribution"
  | "calculation"
  | "disabled_send_by_marketplace";
const record = (key: string, props: string[]) => {
  localStorage.setItem(key, JSON.stringify(props));
};
const defaultState: ColunmName[] = [
  "remnants",
  "reserved",
  "combo_distribution",
  "distribution",
  "calculation",
  "disabled_send_by_marketplace",
];
const read = (): ColunmName[] | null => {
  const value = localStorage.getItem(keyDefault);
  try {
    if (!value) throw new Error();
    const parsed = JSON.parse(value);
    if (!(parsed instanceof Array)) throw new Error();
    const filtered = parsed.filter((el) => defaultState.includes(el)) as ColunmName[];
    if (!filtered.length) throw new Error();
    return filtered;
  } catch (e) {}
  return null;
};

export const useColumnControl = () => {
  const [state, setState] = useState(read() || defaultState);
  const update = (name: ColunmName, value: boolean) => {
    console.log("!!!", name, value, state);
    setState(value ? [...state, name] : state.filter((el) => el !== name));
  };

  useEffect(() => {
    record(keyDefault, state);
  }, [state]);

  return {
    remnantsChecked: state.includes("remnants"),
    reservedChecked: state.includes("reserved"),
    comboDistributionChecked: state.includes("combo_distribution"),
    distributionChecked: state.includes("distribution"),
    calculationChecked: state.includes("calculation"),
    disabledSendByMarketplaceChecked: state.includes("disabled_send_by_marketplace"),
    update,
  };
};

export type ColumnControl = ReturnType<typeof useColumnControl>;
